'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import { IReview } from 'app/interfaces/reviews';
import SwiperButtonPrev from 'app/components/common/SwiperButtonPrev';
import SwiperButtonNext from 'app/components/common/SwiperButtonNext';
import ReviewCard from './ReviewCard';

export default function Reviews({ items }: { items:IReview[] }) {
  return (
    <section className="pt-15 md:pt-27 xl:pt-36 pb-29 md:pb-30 xl:pb-47">
      <div className="relative flex flex-col gap-2.5 md:gap-5 xl:gap-0 w-full wrapper-main wrapper-max xl:pt-30">
        <h2 className="xl:absolute xl:top-65 xl:right-1/2 xl:translate-x-1/2 text-line text-brown opacity-50">
          Отзывы
        </h2>
        <div className="absolute -bottom-[90px] md:-bottom-[200px] -left-[328px] md:-left-[368px] xl:-left-[468px] w-[300px] md:w-[369px] xl:w-[579px] h-[461px] md:h-[608px] xl:h-[887px] rotate-45 bg-green rounded-full blur-[84px] xl:blur-[144px] opacity-50" />
        <div>
          <Swiper>
            {items.map((review, index) => (
              <SwiperSlide key={index}>
                <ReviewCard
                  text={review.content}
                  authorName={review.author_name}
                  avatar={review.author_image}
                  date={review.date_published}
                  image={review.image}
                />
              </SwiperSlide>
            ))}
            <div className="absolute z-10 right-0 bottom-0 flex gap-1 justify-end">
              <SwiperButtonPrev className="button w-13 h-13 rounded bg-graphite-dark transition-opacity duration-300" />
              <SwiperButtonNext className="button w-13 h-13 rounded bg-graphite-dark transition-opacity duration-300" />
            </div>
          </Swiper>
        </div>
      </div>
    </section>
  );
}
